module.exports = __webpack_public_path__ + "static/media/Template.715dac58.svg";